import { SKU_DATA_LOADED } from 'src/constants/sku';

export const skuDataLoaded = ({ skuId, skuData }) => ({
  type: SKU_DATA_LOADED,
  skuId,
  skuData,
});
